type Geometry = {
  type: 'Polygon';
  coordinates: number[][][];
};

type Properties = {
  deliveryZoneId: number;
};

type Feature = {
  id: number;
  type: 'Feature';
  properties: Properties;
  geometry: Geometry;
};

export type ChangedGeometry = {
  features: Feature[];
};

export enum deliveryZoneState {
  EDITED,
  NEW,
  DELETED,
  UNMODIFIED,
}

export type Polygon = {
  id: string | number | undefined;
  type: 'Feature';
  properties: {
    edited?: string;
    active?: string;
    active_is_nightsale_only?: string;
    active_delivery_redirected?: string;
    deliveryZoneId?: number;
    priceffTagId?: string;
    color?: string;
  };
  geometry: {
    coordinates: [number, number][][];
    type: 'Polygon';
  };
};

export type DrawObject = {
  features: Array<Polygon>;
};

export type ZoneIdGeometry = {
  id: number;
  geometry?: [number, number][][];
};

export type DynamicPriceZoneIdGeometry = {
  priceffTagId: string;
  deliveryZoneId: number;
  geometry?: [number, number][][];
  color: string;
};

type Coordinate = {
  latitude: number;
  longitude: number;
};

export type GeoJsonPolygon = {
  coordinates: Coordinate[][];
  properties: Record<string, unknown> | null;
};
